import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import { useOrg } from './useOrg';

const fallbackType = { key: 'unknown', label: 'Appointment', color: '#6B7280' };

export function useAppointmentTypes() {
  const { currentOrg } = useOrg();
  const [types, setTypes] = useState([]);
  const [typesMap, setTypesMap] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchTypes = useCallback(async () => {
    if (!currentOrg) return;
    try {
      const data = await api.getAppointmentTypes(currentOrg.id);
      setTypes(data);
      const map = {};
      for (const t of data) {
        map[t.key] = { label: t.label, color: t.color, id: t.id, default_charge: t.default_charge ?? null };
      }
      setTypesMap(map);
    } catch (err) {
      console.error('Failed to fetch appointment types:', err);
    } finally {
      setLoading(false);
    }
  }, [currentOrg]);

  useEffect(() => { fetchTypes(); }, [fetchTypes]);

  const getType = (key) => typesMap[key] || fallbackType;

  return { types, typesMap, loading, getType, refetch: fetchTypes };
}
